import React from 'react';
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import {Parts} from "../../../../../components";
import { useDropzone } from "react-dropzone";
import {Tooltip} from "@material-ui/core";
import Download from '@material-ui/icons/GetApp'
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: 'Data Entry',
	url: '/dataEntry',
	icon: 'dashboard'
}];

export default class DataEntry extends Framework.Components.View {

	constructor(props) {
		super(props, 'data');
		this.state.dataSubmitted = false;
		this.state.w9filledout = false;
		this.state.tab = 'data';
	}

	getHashTab = () => {
		if (typeof window === 'undefined' || !window.location.hash) {
			return '';
		}
		return window.location.hash.replace('#', '');
	};

	resolveOnboardingTab = (dataSubmitted, w9filledout, preferred) => {
		const unlocked = ['data'];
		if (dataSubmitted) unlocked.push('w9');
		if (w9filledout) unlocked.push('images');
		if (preferred && unlocked.includes(preferred)) {
			return preferred;
		}
		if (!dataSubmitted) return 'data';
		if (!w9filledout) return 'w9';
		return 'images';
	};

	applyOnboardingProgress = (partial) => {
		this.setState((prev) => {
			const dataSubmitted = Object.prototype.hasOwnProperty.call(partial, 'dataSubmitted')
				? partial.dataSubmitted
				: prev.dataSubmitted;
			const w9filledout = Object.prototype.hasOwnProperty.call(partial, 'w9filledout')
				? partial.w9filledout
				: prev.w9filledout;
			return {
				...prev,
				...partial,
				dataSubmitted,
				w9filledout,
				tab: this.resolveOnboardingTab(dataSubmitted, w9filledout, this.getHashTab()),
			};
		}, () => {
			const tab = this.state.tab;
			if (this.props.history && this.getHashTab() !== tab) {
				this.props.history.replace('#' + tab);
			}
		});
	};

	visibleTab = (state = this.state) => this.resolveOnboardingTab(
		state.dataSubmitted,
		state.w9filledout,
		state.tab
	);

	handleTabChange = (event, newValue) => {
		const tab = this.visibleTab({...this.state, tab: newValue});
		this.props.history.push('#' + tab);
		this.setState({tab});
	};

	render() {
		const tab = this.visibleTab();
		return(
			<div key={this.state.dataSubmitted} className={'container-fluid'} style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
				<Tabs value={tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Data Entry" value="data"/>
					{!this.state.dataSubmitted ? (
						<Tooltip title="Please complete the General Data Entry tab first">
							<span style={{ display: "inline-block" }}>
								<Tab label="W9 Data Entry" value="w9" disabled />
							</span>
						</Tooltip>
					) : (
						<Tab label="W9" value="w9"/>
					)}
					{!this.state.w9filledout ? (
						<Tooltip title="Please complete the General Data Entry and W9 Data Entry tabs first">
							<span style={{ display: "inline-block" }}>
								<Tab label="Files Upload" value="images" disabled />
							</span>
						</Tooltip>
					) : (
						<Tab label="File Upload" value="images"/>
					)}
				</Tabs>

				<div className={classNames({'hidden': tab !== 'data'})}>
					<div style={{position: 'relative', justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
						{this.state.onboarding_message ? <p><b>{this.state.onboarding_message}</b></p> : <b>Please submit all data required below.</b>}
						{this.state.onboarding_message?.includes('mobile app') &&
							<div>
							<p>
							<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/accounts/downloadapp`}>
								<Button
									color="primary"
									style={{
										display: "flex",
										alignItems: "center",
										gap: "0.5rem",
										textDecoration: "none",
										width: "12rem",
									}}
								>
									<Download size={18} />
									<span>Download App</span>
								</Button>
							</a>
							</p>
								{this.state.onboarding_message ? <p><b>Please wait while we run your background check. <br/> Once you pass you can log into your webmail at <a href={"https://www.karlstechnology.com/webmail"}>www.karlstechnology.com/webmail</a> with the password you just set.<br/> Check your webmail for links to setup your square and slack accounts. </b></p> : ""}
							</div>
						}
						{/*	DD info*/}

						{/*	Address*/}
						<Parts.DataEntry
							id={this.props.user}
							step={1}
							noDelete={false}
							setDataSubmit={() => this.setState({dataSubmitted: true})}
							setOnboardingProgress={this.applyOnboardingProgress}
							setOnboardingMessage={(message) => this.setState({onboarding_message: message})}
							setTab={() => {
								this.setState((prev) => {
									const nextTab = this.resolveOnboardingTab(true, prev.w9filledout, 'w9');
									if (this.props.history) {
										this.props.history.push('#' + nextTab);
									}
									return {dataSubmitted: true, tab: nextTab};
								});
							}}
						/>
					</div>
				</div>


				<div className={classNames({'hidden': tab !== 'w9'})}>
					<div style={{position: 'relative', justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
						{this.state.onboarding_message ? <b>{this.state.onboarding_message}</b> : <b>Please upload all files requested below. You will be redirected to your user profile after submitting, and will be forced to choose your password.</b>}
						{this.state.onboarding_message?.includes('mobile app') &&
							<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/accounts/downloadapp`}>
							<Button
							color="primary"
							style={{
								display: "flex",
								alignItems: "center",
								gap: "0.5rem",
								textDecoration: "none",
								width: "12rem"
							}}
						>
							<Download size={18} />
							<span>Download App</span>
						</Button>
							</a>}

						<Parts.DataEntry
							id={this.props.user}
							step={2}
							setW9FilledOut={() => this.setState({w9filledout: true})}
							setOnboardingProgress={this.applyOnboardingProgress}
							noDelete={false}
							setOnboardingMessage={(message) => this.setState({onboarding_message: message})}
							setTab={() => {
								this.setState((prev) => {
									const nextTab = this.resolveOnboardingTab(prev.dataSubmitted, true, 'images');
									if (this.props.history) {
										this.props.history.push('#' + nextTab);
									}
									return {w9filledout: true, tab: nextTab};
								});
							}}
						/>

						{/*	W9 data*/}
					</div>
				</div>

				<div className={classNames({'hidden': tab !== 'images'})}>
					<div style={{position: 'relative', justifyContent: 'center', display: 'flex', flexDirection: 'column'}}>
						{this.state.onboarding_message ? <b>{this.state.onboarding_message}</b> : <b>Please upload all files requested below. You will be redirected to your user profile after submitting, and will be forced to choose your password.</b>}
						{this.state.onboarding_message?.includes('mobile app') &&
							<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/accounts/downloadapp`}>
								<Button
									color="primary"
									style={{
										display: "flex",
										alignItems: "center",
										gap: "0.5rem",
										textDecoration: "none",
										width: "12rem"
									}}
								>
									<Download size={18} />
									<span>Download App</span>
								</Button>
							</a>}

						<Parts.DataEntry
							id={this.props.user}
							step={3}
							noDelete={false}
							setOnboardingProgress={this.applyOnboardingProgress}
							setOnboardingMessage={(message) => this.setState({onboarding_message: message})}
						/>
						{/*	DL front*/}

						{/*	DL back*/}

					</div>
				</div>

			</div>


		)
	}
}